import React, { createContext, useEffect, useState } from "react";

const ConnectionContext = createContext();

export function ConnectionProvider({ children }) {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
    };

    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return (
    <ConnectionContext.Provider value={isOnline}>
      {children}
    </ConnectionContext.Provider>
  );
}

export default ConnectionContext;
